'use server';

import { searchDocuments, updateDocument } from "@/lib/elasticsearch";
import { PaginatedResponse } from "@/lib/types";
const CANDIDATES_INDEX = 'hellojobv5-job-crawled';
import * as AWS from "aws-sdk";
import { FileMimeType } from "@/lib/file-mime-type";
import { revalidateTag, unstable_cache } from "next/cache";
import { createSearchQuery } from "./jobs-action";

export const getJobByCode = (jobID: string) => {
    jobID = jobID?.toUpperCase();
    return unstable_cache(
        async () => {
            const searchQuery = {
                query: {
                    bool: {
                        filter: [{
                            bool: {
                                should: [
                                    { term: { "code.keyword": jobID } },
                                    { term: { "id.keyword": jobID } }
                                ],
                                minimum_should_match: 1
                            }
                        }]
                    }
                }
            }
            console.log(JSON.stringify(searchQuery));
            try {
                const results = await searchDocuments<any>(CANDIDATES_INDEX, searchQuery, 1, 1);
                // console.log(results)
                if (results.docs.length > 0) {
                    const doc = results.docs[0];
                    return { ...doc, id: doc.id, source: doc.source };
                }
                return null;
            } catch (error: any) {
                console.error("Failed to fetch candidate by Code:", error);
                return null;
            }
        },
        [`job-detail-${jobID}-${Date.now}`], // Cache key duy nhất cho mỗi code
        {
            tags: ['jobs', `job-detail-${jobID}-${Date.now}`], // Đánh 2 loại tag: tag chung và tag định danh
            revalidate: 3600
        }
    )();
};
export const findSuggestedJobs = async (jobID: string, filter: any): Promise<PaginatedResponse<any>> => {
    // Tạo một cache key dựa trên các thuộc tính của job để đảm bảo tính duy nhất
    const cacheKey = `suggested-jobs-${jobID || 'default'}`;
    // return unstable_cache(
    //     async () => {
    try {
        const query = await createSearchQuery(filter, null);
        // if (!query.bool.must_not) {
        //     query.bool.must_not = [];
        // }
        query.query.bool.filter.push(
            {
                bool: {
                    must_not: [
                        {
                            term: {
                                "id.keyword": jobID,
                            }
                        }
                    ]
                },
            }
        )
        // Giới hạn field trả về để nhẹ payload
        query._source = [
            "id",
            "nameAscii",             // Định danh document
            "code",             // Mã công việc hiển thị trên ảnh
            "avatar",           // Ảnh đại diện công việc
            "job",              // Tên công việc (dùng để lấy ảnh mặc định nếu ko có avatar)
            "career",           // Ngành nghề (dùng để lấy ảnh mặc định)
            "visa",             // Thông tin Visa để hiển thị Badge
            "realSalary",       // Lương thực lĩnh
            "basicSalary",             // Thông tin Visa để hiển thị Badge
            "realSalaryCode",       // Lương thực lĩnh
            "basicSalaryCode",      // Lương cơ bản
            "workLocation",     // Địa điểm làm việc
            "interviewDay",     // Ngày phỏng vấn
            "postedDate",       // Ngày đăng (convertTime)
            "time",             // Trường dự phòng cho ngày đăng
            "createdDate",      // Trường dự phòng cho ngày đăng
            "expiredDate",      // Ngày hết hạn để hiển thị trạng thái
            "salerID",          // Để tìm thông tin tư vấn viên (recruiter)
            "source",           // Nguồn gốc (ZALO, FACEBOOK,...) dùng cho Admin logic
            "sender",           // Tên người gửi (hiển thị NameAvatar)
            "formImage",        // Ảnh form đơn hàng
            "formMarkdownArray", // Dùng để generate HTML form
            "specialConditions",
            "fee",
            "numberRecruits",
            "minAge",
            "maxAge",
            "languageLevel",
            "interviewRounds",
            "interviewLocation",
            "educationLevel",
            "experience",
            "experienceYear",
            "height",
            "weight",
            "vgb",
            "haveTattoo",
            "vision",
            "interviewFormat",
            "baseContent",
            "aiContent",
            "baseContent",
            "contact",
            "groupLink",
            "postLink",
            "senderLink",
            "groupName",
            "filter"
        ];
        query.query.bool.filter.push({
            "range": {
                "expiredDate": {
                    "gte": Date.now(),
                }
            }
        });

        const results = await searchDocuments<any>(CANDIDATES_INDEX, query, 1, 4);
        const mappedDocs = results.docs.map(doc => ({
            ...doc,
            id: doc.id,
            source: doc.source,
        }));
        return { ...results, docs: mappedDocs };
    } catch (error: any) {
        return { docs: [], total: 0, page: 1, limit: 4, totalPages: 0 };
    }
    //     },
    //     [cacheKey],
    //     { tags: ['jobs', `suggested-${jobID}`], revalidate: 1800 } // Cache 30 phút
    // )();
};
export const updateJob = async (job: any, avatarFile: File | null, formImageFile: File | null) => {
    let avatarRelativePath, formImagePath;
    const s3 = new AWS.S3({ endpoint: process.env.AWS_MEDIA_END_POINT });
    try {
        if (!!avatarFile || !!formImageFile) {
            AWS.config.update({
                accessKeyId: process.env.AWS_ACCESS_KEY_ID,
                secretAccessKey: process.env.AWS_SECRET_ACCESS_KEY,
                signatureVersion: "v4",
            });
        }
        if (!!avatarFile) {
            const buffer = Buffer.from(await avatarFile.arrayBuffer());
            const folderUploadPrefix = `upload/hellojobv5/job-avatar/`;
            let mimeType = avatarFile.type;
            if (!FileMimeType[mimeType]) {
                mimeType = "image/png";
            }
            const filename = job.id + "_" + Date.now() + "." + FileMimeType[mimeType];
            const params: any = {
                Bucket: process.env.AWS_MEDIA_BUCKET_NAME,
                Key: folderUploadPrefix + filename,
                Body: buffer,
                ContentType: avatarFile.type,
                ContentDisposition: "inline",
            };
            await s3.putObject(params).promise();
            avatarRelativePath = folderUploadPrefix + filename;
            const avatarUrl = `https://cdn.hellojob.jp/${folderUploadPrefix + filename}`;
            job.avatar = avatarUrl;
        }
        if (!!formImageFile) {
            const buffer = Buffer.from(await formImageFile.arrayBuffer());
            const folderUploadPrefix = `upload/hellojobv5/job-form/`;
            let mimeType = formImageFile.type;
            if (!FileMimeType[mimeType]) {
                mimeType = "image/png";
            }
            const filename = job.id + "_" + Date.now() + "." + FileMimeType[mimeType];
            const params: any = {
                Bucket: process.env.AWS_MEDIA_BUCKET_NAME,
                Key: folderUploadPrefix + filename,
                Body: buffer,
                ContentType: formImageFile.type,
                ContentDisposition: "inline",
            };
            await s3.putObject(params).promise();
            formImagePath = folderUploadPrefix + filename;
            const avatarUrl = `https://cdn.hellojob.jp/${folderUploadPrefix + filename}`;
            job.formImage = avatarUrl;
        }
        await updateDocument(CANDIDATES_INDEX, job.id, job);
        revalidateTag(`job-detail-${job.id}`);
        revalidateTag(`suggested-${job.id}`);
        revalidateTag('jobs-list')
        return true;
    } catch (e) {
        if (!!avatarRelativePath) {
            await s3
                .deleteObject({
                    Key: avatarRelativePath,
                    Bucket: process.env.AWS_MEDIA_BUCKET_NAME ?? "",
                })
                .promise();
        }
        if (!!formImagePath) {
            await s3
                .deleteObject({
                    Key: formImagePath,
                    Bucket: process.env.AWS_MEDIA_BUCKET_NAME ?? "",
                })
                .promise();
        }
    }
    return false;
}
export const closeJob = async (jobID: string) => {
    try {
        await updateDocument(CANDIDATES_INDEX, jobID, {
            isClosed: true
        });
        revalidateTag(`job-detail-${jobID}`);
        revalidateTag(`suggested-${jobID}`);
        revalidateTag('jobs-list')
        return true;
    } catch (error) {
        console.log(error);
    }
    return false;
}

// export const convertToPDF = async (htmlContent: string) => {
//     try {
//         console.log(0)
//         const browser = await puppeteer.launch({
//             headless: true,
//             args: [
//                 '--no-sandbox',
//                 '--disable-setuid-sandbox',
//                 // The following args are recommended for running in Docker/containerized environments
//                 '--disable-dev-shm-usage',
//                 '--disable-accelerated-2d-canvas',
//                 '--no-first-run',
//                 '--no-zygote',
//                 '--single-process', // This is not recommended for general use, but can help in resource-constrained environments
//                 '--disable-gpu'
//             ]
//         });
//         console.log(1)
//         const page = await browser.newPage();
//         console.log(2)
//         await page.setContent(htmlContent, { waitUntil: 'networkidle0' });
//         console.log(3)

//         // Generate the PDF
//         const pdfBuffer = await page.pdf({
//             format: 'A4',
//             printBackground: true, // Crucial for including CSS background colors
//             margin: {
//                 top: '20px',
//                 right: '20px',
//                 bottom: '20px',
//                 left: '20px'
//             }
//         });
//         console.log(4)

//         // Close the browser
//         await browser.close();
//         console.log(5)

//         // Return the PDF as a Base64 string
//         return pdfBuffer.toString();
//     } catch (error: any) {
//         // console.log(error)
//     }
// }